import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { BranchReadinessItem } from "../../types/branch.type";
import { resolveItemStatus } from "./branchStatus";
import { LEVEL_LABEL, READINESS_GUIDE } from "./constants";
import ReadinessChip from "./ReadinessChip";
import { ReadinessGuideLink } from "./ReadinessGuide";

/** The branch-level items (GM, vehicle, back-office users), in the order the server sends. */
export default function BranchItemTable({
  items,
}: Readonly<{ items: BranchReadinessItem[] }>) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead sx={{ bgcolor: "background.default" }}>
          <TableRow>
            <TableCell>รายการ</TableCell>
            <TableCell align="center">ระดับ</TableCell>
            <TableCell align="center">สถานะ</TableCell>
            <TableCell>ใครทำ</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.key}>
              <TableCell>{READINESS_GUIDE[item.key].label}</TableCell>
              <TableCell align="center">{LEVEL_LABEL[item.level]}</TableCell>
              <TableCell align="center">
                <ReadinessChip view={resolveItemStatus(item)} />
              </TableCell>
              <TableCell>
                <ReadinessGuideLink guide={READINESS_GUIDE[item.key]} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
